//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DTDropdownItemInjector } from '../../keys'

export default {
  inject: {
    dropdown: {
      from: DTDropdownItemInjector,
      default: null,
    },
  },
  props: {
    alignWithIcon: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    to: {
      type: [Object, String],
      default: null,
    },
  },
  computed: {
    tag() {
      if (this.href) {
        return 'a'
      } else if (this.to) {
        return 'nuxt-link'
      }
      return 'button'
    },
    tagProperties() {
      switch (this.tag) {
        case 'a':
          return { href: this.href }
        case 'nuxt-link':
          return { to: this.to }
        case 'button':
        default:
          return {}
      }
    },
    bound() {
      return Object.assign({}, this.$attrs, this.tagProperties)
    },
    listeners() {
      return Object.assign({}, this.$listeners, {
        // mousedown and focusout listeners are here because of Safari FEATURE
        // which doesn't set focus on button when clicked
        mousedown: (event) => {
          this.$el.focus()
          this.$emit('mousedown', event)
        },
        focusout: (event) => {
          this.$nextTick(() => {
            if (!this.dropdown.el().contains(event.target)) {
              this.dropdown.toggle()
            }
          })
          this.$emit('focusout', event)
        },
        click: (event) => {
          this.$emit('click', event)
          this.dropdown.toggle()
        },
      })
    },
  },
  beforeMount() {
    if (!this.dropdown) {
      throw new Error('Trying to use DTDropdownItem outside DTDropdown')
    }
  },
}
